import {
    REQUEST_FETCH_CRUISE_LOGS,
    FETCH_CRUISE_LOGS_SUCCESS,
    FETCH_CRUISE_LOGS_ERROR,
  } from '../../../actions/reservations/cruise/fetchCruiseLogs';
    
  const initialState = {
    logs: [],   
    processing: false,
    fetching: false,
    message: "",
    error: "",
  };
  
  const cruiseLogReducer = (state = initialState, action) => {
    switch (action.type) {
      case REQUEST_FETCH_CRUISE_LOGS: {
        return {
          ...state,
          logs: [],
         
          processing: false,
          fetching: true,
          message: "",
          error: "",
        };
      }
      case FETCH_CRUISE_LOGS_SUCCESS: {
        return {
          ...state,
          logs: action.logs,
         
          processing: false,
          fetching: false,
          message: "",
          error: "",
        };
      }
      case FETCH_CRUISE_LOGS_ERROR: {
        return {
          ...state,
          logs: [],
         
          processing: false,
          fetching: false,
          message: "",
          error: action.error,
        };
      }
     
      default: {
        return state;
      }
    }
  };
  
  export default cruiseLogReducer;
  